let ol = require('openlayers');
let Map = require('./../../core/map');

class StyleViewerMap {
  constructor(params) {
    this.map = new Map(params.map || {});
    this.layer = this.map.getGraphics();
    this.fields = params.fields;
    this.geometryType = params.geometryType || "Point";
    this.init();
  }

  init() {
    this.initFeature();
    this.centerView();
  }

  initFeature() {
    let properties = {};
    this.fields.forEach((field) => {
      let key = field.name;
      let typeField = "binding";
      switch (field[typeField]) {
        case "java.sql.Date":
          properties[key] = new Date();
          break;
        case "java.sql.Time":
          properties[key] = new Date();
          break;
        case "java.sql.Timestamp":
          properties[key] = new Date();
          break;
        case "java.sql.String":
          properties[key] = "Значение по умолчанию в поле " + key;
          break;
        case "java.sql.Boolean":
          properties[key] = Math.random() > 0.5;
          break;
        case "java.sql.Integer":
          properties[key] = Number((Math.random() * 100).toFixed(0));
          break;
        case "java.sql.Long":
          properties[key] = Number((Math.random() * 1000).toFixed(0));
          break;
        case "java.sql.Double":
          properties[key] = Number((Math.random() * 100).toFixed(4));
          break;
        case "java.sql.Float":
          properties[key] = Number((Math.random() * 100).toFixed(2));
          break;
        case "string":
          properties[key] = "Значение по умолчанию в поле " + key;
          break;
        case "number":
          properties[key] = Number((Math.random() * 100).toFixed(2));
          break;
        default:
          properties[key] = 1;
          break;
      }
    });
    let geometryType = this.geometryType;
    let geometryConstructor = ol.geom[geometryType];
    let geometry = new geometryConstructor(this.getCoordinates(geometryType));
    properties.geometry = geometry;
    let feature = new ol.Feature(properties);
    this.layer.add({feature: feature});
    this.feature = feature;
  }

  centerView() {
    let self = this;
    let extent = self.feature.getGeometry().getExtent();
    self.map.setExtent({extent: extent, nearest: false})
    if (self.geometryType === "Point") self.map.map.getView().setZoom(15);
  }

  getCoordinates(type) {
    let dict = {
      Point: [3374647, 8420043],
      LineString: [[3404930, 8354744], [3419975, 8348849]],
      Polygon: [
        [
          [
            3123641.0951000005,
            8195044.4931000024
          ],
          [
            3123677.5221000016,
            8195024.7866000012
          ],
          [
            3123660.5029000007,
            8194994.9284000024
          ],
          [
            3123623.4787000008,
            8195017.3220999986
          ],
          [
            3123641.0951000005,
            8195044.4931000024
          ]
        ]
      ]
    };
    return dict[type];
  }

  setStyle(style) {
    this.layer.setStyle(style);
  }
}

module.exports = StyleViewerMap;